import { FaSearchLocation, FaBoxOpen } from "react-icons/fa";

interface IProps {
  trackingCode: string;
}

export function TrackingNotFound({ trackingCode }: IProps) {
  return (
    <div className="container-fluid py-4">
      <div className="card-body text-center py-5 px-4">
        {/* Icon Stack */}
        <div className="position-relative d-inline-block mb-4">
          {/* Background Circle */}
          <div
            className="position-absolute rounded-circle"
            style={{
              width: "120px",
              height: "120px",
              backgroundColor: "rgba(95, 196, 217, 0.1)",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              animation: "pulse 2s ease-in-out infinite",
            }}
          />

          {/* Icon */}
          <div
            className="rounded-circle d-flex align-items-center justify-content-center position-relative"
            style={{
              width: "100px",
              height: "100px",
              backgroundColor: "#5fc4d9",
              color: "white",
            }}
          >
            <FaBoxOpen size={48} />
            <div
              className="position-absolute"
              style={{
                bottom: "-5px",
                right: "-5px",
                backgroundColor: "#ff6b6b",
                borderRadius: "50%",
                padding: "8px",
                border: "3px solid white",
              }}
            >
              <FaSearchLocation size={20} color="white" />
            </div>
          </div>
        </div>

        {/* Message */}
        <h3 className="fw-bold mb-3" style={{ color: "#2d3748" }}>
          Pedido não encontrado
        </h3>
        <h3 className="fw-bold mb-3" style={{ color: "#2d3748" }}>
          {trackingCode}
        </h3>

        <p
          className="text-muted mb-4"
          style={{ fontSize: "16px", lineHeight: "1.6" }}
        >
          Não conseguimos localizar nenhum pedido com o código de rastreio
          informado.
        </p>

        {/* Info Box */}
        <div
          className="alert mb-4"
          style={{
            backgroundColor: "rgba(95, 196, 217, 0.1)",
            border: "1px solid rgba(95, 196, 217, 0.3)",
            borderRadius: "12px",
          }}
        >
          <div className="d-flex align-items-start gap-3 text-start">
            <div className="mt-1">
              <i
                className="fa fa-info-circle"
                style={{ color: "#5fc4d9", fontSize: "20px" }}
              ></i>
            </div>
            <div>
              <strong className="d-block mb-2" style={{ color: "#2d3748" }}>
                Dicas:
              </strong>
              <ul
                className="mb-0 ps-3"
                style={{ fontSize: "14px", color: "#4a5568" }}
              >
                <li className="mb-1">
                  Verifique se o código foi digitado corretamente
                </li>
                <li className="mb-1">
                  Códigos de rastreio geralmente levam algumas horas para serem
                  ativados
                </li>
                <li className="mb-1">
                  Certifique-se de que o pedido já foi despachado
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Help Link */}
        <div className="mt-4 pt-3" style={{ borderTop: "1px solid #e2e8f0" }}>
          <p className="text-muted mb-2" style={{ fontSize: "14px" }}>
            Precisa de ajuda?
          </p>
          <a
            href="/"
            className="text-decoration-none fw-semibold"
            style={{ color: "#5fc4d9", fontSize: "14px" }}
          >
            Entre em contato conosco
          </a>
        </div>
      </div>
    </div>
  );
}
